'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Details2 = require('./Details');

var _Details3 = _interopRequireDefault(_Details2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A collection of course details
 * @param {number} count the number of course details returned
 * @param {string} lastKey the pagination key for the last item
 * @param {Array.<CourseDetail>} courses the course details
 */


var CourseDetails = function (_Details) {
  (0, _inherits3.default)(CourseDetails, _Details);

  function CourseDetails(fields) {
    (0, _classCallCheck3.default)(this, CourseDetails);
    return (0, _possibleConstructorReturn3.default)(this, (CourseDetails.__proto__ || (0, _getPrototypeOf2.default)(CourseDetails)).call(this, fields, 'courses'));
  }

  return CourseDetails;
}(_Details3.default);

exports.default = CourseDetails;